import settingsConfig from './settings/settingsConfig'
import connectConfig from './connect/connectConfig'
import profileConfig from './profile/profileConfig'

import ecommerceConfig from './ecommerce/ecommerceConfig'

export const projectConfig = [
  profileConfig,
  settingsConfig,
  connectConfig,
  ...ecommerceConfig,
]



// WEBPACK FOOTER //
// ./src/main/content/project/projectConfig.js